import EstimatedValue from '../src/EstimatedValue';
export default EstimatedValue;
